// Raghu 12/23/2022 3031689933 Table settings popup Button enhancements
// Raghu 02/27/2023 3031689933 added new class name for buttons
import React, {useState, useEffect, useContext} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {useDispatch, useSelector} from 'react-redux';
import {Button} from '@material-ui/core';
import {
  fetchColumns,
  postColumns,
  SuccessMsg as successMsg,
  resetColumnStatus,
} from '../../redux/reducers/DashboardSettings';
import SelectTabContextProvider from '../../components/SelectTabContext/SelectTabContext';

import {
  fetchW3Columns,
  postW3Columns,
  resetToast,
  resetW3ColumnStatus,
} from '../../redux/reducers/coreWindows/MultipleAccountInformation';
import PageLoader from '../../components/PageLoader';
import {ErrorSnackbar} from '../../components/CustomSnackBar';
import ResultViewChips from './ResultViewChips2';
import ColoumnChips from './ColumnChips';
import {DragDropContext} from 'react-beautiful-dnd';
import searchData from './SearchData';
import MultipleAccountData from './MultipleAccountData';
import {ThemeContext} from '../../themes/ThemeProvider';

const SettingsForm = ({handleClose}) => {
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {settingsW3} = useContext(SelectTabContextProvider);
  const [chipData, setChipData] = useState((settingsW3 && MultipleAccountData) || searchData);
  const {columnData, isLoading, errorMsg, columnStatus} = useSelector(({columns}) => columns);
  const {columnStatusW3, columnDataW3, isLoadingW3} = useSelector(
    ({multipleAccountInfo}) => multipleAccountInfo,
  );
  const handleSave = () => {
    if (chipData) {
      if (settingsW3) {
        dispatch(
          postW3Columns({
            windowCode: 'W3',
            columnName: chipData && chipData['columns']['column-2']['taskIds'],
          }),
        );
      } else {
        dispatch(
          postColumns({
            windowCode: 'dashboard',
            columnName: chipData && chipData['columns']['column-2']['taskIds'],
          }),
        );
      }
    }
  };
  const initialValues = {};
  const user = JSON.parse(sessionStorage.getItem('userDetails'));
  const validationSchema = Yup.object().shape({});

  useEffect(() => {
    const searchArr = [];
    const col = chipData.columns[`column-1`];
    const tasks = col.taskIds.map((taskId) => chipData.tasks[taskId]);

    tasks.map((searchParam) => {
      searchArr.push(searchParam.content);
      return;
    });
  }, [chipData]);
  useEffect(() => {
    if (columnStatus === 200) {
      setTimeout(() => {
        dispatch(successMsg());
      }, 3000);
      dispatch(resetColumnStatus());
      handleClose();
      dispatch(fetchColumns(user?.userName));
    }
    if (columnStatusW3 === 200) {
      setTimeout(() => {
        dispatch(resetToast());
      }, 3000);
      dispatch(resetW3ColumnStatus());
      handleClose();
      dispatch(fetchW3Columns(user?.userName));
    }
  }, [columnStatus, columnStatusW3]);
  useEffect(() => {
    const first = settingsW3 ? columnDataW3?.columnName : columnData?.columnName;
    const second = chipData?.columns[`column-1`].taskIds;
    const removeCommon = (first, second) => {
      if (settingsW3) {
        const spreaded = columnDataW3?.columnName ? [...first, ...second] : [...second];
        return spreaded.filter((el) => {
          return !(first?.includes(el) && second.includes(el));
        });
      } else {
        const spreaded = columnData?.columnName ? [...first, ...second] : [...second];
        return spreaded.filter((el) => {
          return !(first?.includes(el) && second.includes(el));
        });
      }
    };
    const columnData2 = {
      ...chipData.columns['column-2'],
      taskIds: settingsW3 ?
        columnDataW3?.columnName && columnDataW3.columnName[0] !== '' ?
          columnDataW3.columnName :
          [] :
        columnData?.columnName && columnData.columnName[0] !== '' ?
          columnData.columnName :
          [],
    };
    const columnData1 = {
      ...chipData.columns['column-1'],
      taskIds: settingsW3 ?
        columnDataW3?.columnName && columnDataW3.columnName[0] !== '' ?
          removeCommon(first, second) :
          [...second] :
        columnData?.columnName && columnData.columnName[0] !== '' ?
          removeCommon(first, second) :
          [...second],
    };
    const newData = {
      ...chipData,

      columns: {
        ...chipData.columns,
        [columnData2.id]: columnData2,
        [columnData1.id]: columnData1,
      },
    };
    setChipData(newData);
  }, []);
  const handleDelete = (task, index) => {
    const start = chipData.columns['column-2'];
    const finish = chipData.columns['column-1'];
    if (start === finish) {
      const newTaskIds = Array.from(start.taskIds);
      newTaskIds.splice(index, 1);
      newTaskIds.splice(chipData['columns']['column-1']['taskIds'].length, 0, task.id);

      const newColumn = {
        ...start,
        taskIds: newTaskIds,
      };

      const newData = {
        ...chipData,
        columns: {
          ...chipData.columns,
          [newColumn.id]: newColumn,
        },
      };
      setChipData(newData);
      return;
    }

    // Moving from one list to another
    const startTaskIds = Array.from(start.taskIds);
    // Remove dragged taskId from this array
    startTaskIds.splice(index, 1);
    const newStart = {
      ...start,
      taskIds: startTaskIds,
    };

    const finishTaskIds = Array.from(finish.taskIds);
    // Insert the draggable Id at destination index
    finishTaskIds.splice(chipData['columns']['column-1']['taskIds'].length, 0, task.id);
    const newFinish = {
      ...finish,
      taskIds: finishTaskIds,
    };

    // updating the state object as per the drag
    const newState = {
      ...chipData,
      columns: {
        ...chipData.columns,
        [newStart.id]: newStart,
        [newFinish.id]: newFinish,
      },
    };
    setChipData(newState);
  };

  const onDragEnd = (result) => {
    const {destination, source, draggableId} = result;

    if (!destination) {
      return;
    }

    if (destination.droppableId === source.droppableId && destination.index === source.index) {
      return;
    }

    const start = chipData.columns[source.droppableId];
    const finish = chipData.columns[destination.droppableId];

    if (start === finish) {
      const newTaskIds = Array.from(start.taskIds);
      newTaskIds.splice(source.index, 1);
      newTaskIds.splice(destination.index, 0, draggableId);

      const newColumn = {
        ...start,
        taskIds: newTaskIds,
      };

      const newData = {
        ...chipData,
        columns: {
          ...chipData.columns,
          [newColumn.id]: newColumn,
        },
      };

      setChipData(newData);
      return;
    }

    // Moving from one list to another
    const startTaskIds = Array.from(start.taskIds);
    // Remove dragged taskId from this array
    startTaskIds.splice(source.index, 1);
    const newStart = {
      ...start,
      taskIds: startTaskIds,
    };

    const finishTaskIds = Array.from(finish.taskIds);
    // Insert the draggable Id at destination index
    finishTaskIds.splice(destination.index, 0, draggableId);
    const newFinish = {
      ...finish,
      taskIds: finishTaskIds,
    };

    // updating the state object as per the drag
    const newState = {
      ...chipData,
      columns: {
        ...chipData.columns,
        [newStart.id]: newStart,
        [newFinish.id]: newFinish,
      },
    };
    setChipData(newState);
  };

  return (
    <React.Fragment>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, {setSubmitting, resetForm}) => {
          resetForm({});
          setSubmitting(false);
          handleClose();
        }}
      >
        {(props) => {
          const {
            handleSubmit,
            handleReset,
            // setFieldValue,
          } = props;

          return (
            <form
              autoComplete="on"
              noValidate
              className="new-standard-textfields"
              onReset={handleReset}
              onSubmit={handleSubmit}
            >
              <div>
                <DragDropContext onDragEnd={onDragEnd}>
                  <div>
                    <ResultViewChips chipData={chipData} />
                  </div>
                  <div className="mt-3 mb-3">
                    <ColoumnChips chipData={chipData} handleDelete={handleDelete} />
                  </div>
                </DragDropContext>
                <div className="col">
                  <div className="row justify-content-center new-standard-textfields">
                    <Button
                      variant="outlined"
                      className={`mx-1 ${classes.buttonRoot} reset-btn`}
                      disabled={isLoading || isLoadingW3}
                      onClick={handleClose}
                      size="large"
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="outlined"
                      className={`mx-1 search-btn ${classes.buttonRoot}`}
                      disabled={isLoading || isLoadingW3}
                      onClick={() => handleSave()}
                      size="large"
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </div>
              {(isLoading || isLoadingW3) && <PageLoader />}
              {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
            </form>
          );
        }}
      </Formik>
    </React.Fragment>
  );
};

export default SettingsForm;
